import {FragmentRowData} from "src/app/model/ReviewData";
import * as React from "react";
import {useEffect, useState} from "react";
import FragmentElement from "src/app/component/review/FragmentElement";
import {observer} from "mobx-react";

interface FragmentRowProps {
    data: FragmentRowData;
}

const PLACE_HOLDER = "%val";

const FragmentRow = observer( (props: FragmentRowProps) => {
    const [segments, setSegments] = useState<string[]>([]);
    const [suffix, setSuffix] = useState<string>('');

    console.log("input data for fragment row is: " + JSON.stringify(props.data));
    const context = props.data.context;
    const elements = props.data.elements;
    console.log("context is: " + JSON.stringify(context) +", elements: "+ JSON.stringify(elements));

    useEffect(() => {
        (async () => {
            const contextSegments = await generateContent();
            setSegments(contextSegments)
        })();
    }, []);


    const generateContent = async () => {
        let start = 0;
        const contextSegments: string[] = [];
        console.log("generate segments for context: "+ context);
        while (context.indexOf(PLACE_HOLDER, start) != -1) {
            const idx = context.indexOf(PLACE_HOLDER, start);
            const item = context.substring(start, idx);
            if (contextSegments.indexOf(item) == -1) {
                contextSegments.push(item);
            }
            start = idx + PLACE_HOLDER.length;
        }
        setSuffix(context.substring(start));
        console.log("generate segments: "+ JSON.stringify(contextSegments));
        return contextSegments;
    }

    return (
        <div className='same-line white default-margin'>
            {segments.map((segment, index) => (
                <div className='same-line white' key={index}><span>{segment}</span>
                    <FragmentElement data={elements[index]} key={index} data-testid='fragment-element'></FragmentElement>
                </div>
            ))
            }
            {suffix}
        </div>
    )
})

export default FragmentRow;